import React from 'react';
import {useSalesforceCampaignMemberFieldQuery} from 'api';
import useSearchParams from '../../../../useSearchParams';
import {Listbox} from '@headlessui/react';
import ArrowDownIcon from './ArrowDownIcon';

type CustomizeItemFilterItem = {
  salesforceCampaignMemberFieldId: string;
  customizeItemValue: string[];
  index: number;
};

export default ({
  salesforceCampaignMemberFieldId,
  customizeItemValue,
  index,
}: CustomizeItemFilterItem) => {
  const {data: {salesforceCampaignMemberField = {}} = {}} =
    useSalesforceCampaignMemberFieldQuery({
      variables: {
        salesforceCampaignMemberFieldId: salesforceCampaignMemberFieldId,
      },
    });

  const customizeItemOptions = () => {
    return (
      salesforceCampaignMemberField?.salesforceCampaignMemberFieldSelectOptions ||
      []
    );
  };

  const {query, setQuery} = useSearchParams();

  const selectedItemNames = (): string[] => {
    return (
      (
        salesforceCampaignMemberField?.salesforceCampaignMemberFieldSelectOptions ||
        []
      )
        ?.filter((option) => customizeItemValue?.includes(option.id))
        ?.map((option) => option.label) || []
    );
  };

  if (!salesforceCampaignMemberFieldId) {
    return <></>;
  }

  return (
    <div className="relative">
      <Listbox
        value={customizeItemValue || []}
        disabled={!salesforceCampaignMemberFieldId}
        multiple
        onChange={(values) => {
          setQuery({
            ...query,
            salesforceCampaignSearchConditions: [
              ...query.salesforceCampaignSearchConditions.slice(0, index),
              {
                salesforce_campaign_member_field_id:
                  salesforceCampaignMemberFieldId,
                field_type: 'select',
                values: values,
              },
              ...query.salesforceCampaignSearchConditions.slice(index + 1),
            ],
          });
        }}>
        <Listbox.Button className="relative px-3 text-left focus:outline-none flex items-center border rounded w-80 min-h-8 h-full bg-white border-[#d9d9d9] justify-between py-1">
          <div className="flex gap-1 min-h-8 w-auto flex-wrap">
            {selectedItemNames().map((name, index) => {
              return (
                <div key={index} className="bg-[#F3F5F7] px-1">
                  {name}
                </div>
              );
            })}
          </div>
          <ArrowDownIcon />
        </Listbox.Button>
        <Listbox.Options className="absolute">
          {customizeItemOptions().map((customizeItemOption) => (
            <Listbox.Option
              className={({active}) =>
                `relative select-none py-2 px-3 cursor-pointer w-80 h-8 pr-10 z-20 truncate ${
                  active ? 'bg-gray-100' : 'bg-white'
                }`
              }
              key={customizeItemOption.id}
              value={customizeItemOption.id}>
              {customizeItemOption.label}
            </Listbox.Option>
          ))}
        </Listbox.Options>
      </Listbox>
    </div>
  );
};
